<div class="c-slide" style="{{#if isIn}}position: absolute; top: 0; width: 100%;{{/if}}">
	{{#if active}}
	<div {{#if fly}}fly-in-out="transitionOptions"{{/if}}>
		{{yield}}
	</div>
	{{/if}}
</div>

<script>
	component.exports = {
		onrender () {
			this.set('fly', true);
		},
	};
</script>
